module.exports = __webpack_public_path__ + "img/26.595c81a4.jpg";